import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type RoleAction = 'read' | 'write' | 'admin';

export interface RolePermissionPayload {
  module_name: string;
  actions: RoleAction[];
  graphs?: string[];
}

export interface CreateRolePayload {
  name: string;
  description: string;
  permissions: RolePermissionPayload[];
}

export interface RoleApiItem {
  _id: string;
  name: string;
  description: string;
  permissions: RolePermissionPayload[];
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface RolesListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    roles?: RoleApiItem[];
    totalCount?: number;
  } | RoleApiItem[];
  totalCount?: number;
}

export interface CreateRoleResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    role?: RoleApiItem;
  };
}

export interface RoleMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    role?: RoleApiItem;
  };
}

export const getRoles = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  'meta.status'?: 'active' | 'inactive';
}): Promise<RolesListResponse> => {
  return api.get<RolesListResponse>(API_ENDPOINTS.roles.list, { params });
};

export const createRole = async (
  payload: CreateRolePayload
): Promise<CreateRoleResponse> => {
  return api.post<CreateRoleResponse, CreateRolePayload>(
    API_ENDPOINTS.roles.create,
    payload
  );
};

export const updateRole = async (
  id: string,
  payload: CreateRolePayload
): Promise<RoleMutationResponse> => {
  return api.patch<RoleMutationResponse, CreateRolePayload>(
    `${API_ENDPOINTS.roles.list}/${id}`,
    payload
  );
};

export const deleteRole = async (id: string): Promise<RoleMutationResponse> => {
  return api.delete<RoleMutationResponse>(`${API_ENDPOINTS.roles.list}/${id}`);
};
